<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, BLOCK } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<BLOCK>
	}

	let { blok }: Props = $props()
</script>

<section class="block {blok.theme}" {...attrs(blok)}>
	<div class="contain"></div>
</section>

<style lang="css">
	.block {
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
	}
</style>
